export default __webpack_public_path__ + "static/m-blog1-9ae65d157959fc767afeff96179d35e7.jpg";